import { useEffect, useState } from 'react';
import { db } from '../../../../../firebase-client';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
export function useTeamMeta(teamId, isOpen) {
  const [tags, setTags] = useState([]);
  const [locations, setLocations] = useState([]);
  const [eventRoles, setEventRoles] = useState([]);
  const [teamCountry, setTeamCountry] = useState('UK');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!isOpen || !teamId) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const teamSnap = await getDoc(doc(db, 'teams', teamId));
        if (!cancelled && teamSnap.exists()) {
          const teamData = teamSnap.data();
          const expanded = (teamData.tags || []).flatMap(tag => {
            if (tag.type !== 'ageRule') return [tag];
            const names = Array.isArray(tag.tagNames) ? tag.tagNames : [tag.tagName];
            return names.filter(name => typeof name === 'string' && name.trim() !== '').map(name => ({
              ...tag,
              name: name.trim(),
              category: 'Age Tags'
            }));
          });
          const deduped = [];
          const seen = new Set();
          expanded.forEach(tag => {
            const key = `${tag.category || 'Uncategorised'}::${tag.name}`;
            if (seen.has(key)) return;
            seen.add(key);
            deduped.push(tag);
          });
          setTags(deduped);
          setTeamCountry(teamData.address?.country || 'UK');
        }
        const [locSnap, roleSnap] = await Promise.all([getDocs(collection(db, 'teams', teamId, 'locations')), getDocs(collection(db, 'teams', teamId, 'eventRoles'))]);
        if (!cancelled) {
          setLocations(locSnap.docs.map(d => ({
            id: d.id,
            ...d.data()
          })));
          setEventRoles(roleSnap.docs.map(d => ({
            id: d.id,
            ...d.data(),
            requiresApproval: d.data()?.requiresApproval !== false
          })).filter(r => r.active !== false));
        }
      } catch (err) {
        // Keep the last successful team metadata during a transient refresh failure.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [teamId, isOpen]);
  return {
    tags,
    locations,
    eventRoles,
    teamCountry,
    loading
  };
}
